import React from 'react';
import PropTypes from 'prop-types';

import MaterialDrawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/styles';
import { CHILDREN_PROPTYPES } from 'bento-ordering/base/constants/propTypes';

const styles = {
  paper: {
    width: 400,
    padding: '0',
    overflowX: 'hidden'
  }
};

/*
  Used to delay render of material drawer so that transition is visible.
  Need to do this since we are rendering this inside the modal portal.
*/
const useDelayRender = () => {
  const [ready, setReady] = React.useState(false);
  setTimeout(() => {
    setReady(true);
  }, 1);

  return ready;
};

const Drawer = props => {
  const { children, anchor, handleClose, classes } = props;
  const ready = useDelayRender();
  return (
    <MaterialDrawer
      classes={classes}
      anchor={anchor}
      open={ready}
      onClose={handleClose}
    >
      <Box padding={2.5} position="relative" height="100%" width="100%">
        {children}
      </Box>
    </MaterialDrawer>
  );
};

Drawer.defaultProps = {
  anchor: 'right',
  isOpen: false
};

Drawer.propTypes = {
  anchor: PropTypes.string,
  handleClose: PropTypes.func,
  children: CHILDREN_PROPTYPES.isRequired,
  classes: PropTypes.shape({
    paper: PropTypes.string
  })
};

export default withStyles(styles)(Drawer);
